module.exports = __webpack_public_path__ + "static/black_abishai-2586cd31936f4015fe4585b2aa48b597.png";